module.exports = __webpack_public_path__ + "img/检测流程.5830d9ea.jpg";